import React from "react";
import { Query } from 'react-apollo';
import Form from "../form/Form";

const Inspect = props => (
  <Query {...props.query} onCompleted={props.onQueryCompleted}>
    {({ loading, data }) => (
      <Form {...props} initialValues={data && data[props.queryName] || props.defaultValues}>
        {form => props.children(loading, data, form)}
      </Form>
    )}
  </Query>
);

export default Inspect;
